module.exports = __webpack_public_path__ + "static/monte-baia-307f7cdbc92bb5c553d629999b51aad8.png";